import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoayodhyacab() {



    const cardData = {

keyword: "Mumbai to Ayodhya Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Ayodhya Cab services for long-distance pilgrimage travel, family tours, and one-way or round-trip journeys. We provide well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup in Mumbai, and safe highway driving across multiple states, we ensure a comfortable, secure, and hassle-free spiritual journey to Ayodhya Ram Mandir and nearby religious destinations.",

topPlaces: [
    {
        title: "Shri Ram Janmabhoomi Mandir (Ayodhya)",
        description:
            "Shri Ram Janmabhoomi Mandir is the most important pilgrimage site in Ayodhya dedicated to Lord Ram. Devotees from Mumbai frequently travel here for darshan and spiritual blessings in a comfortable long-distance cab journey."
    },
    {
        title: "Saryu River Ghats",
        description:
            "The Saryu River Ghats are sacred bathing and prayer spots in Ayodhya where pilgrims perform rituals, aarti, and spiritual ceremonies in a peaceful riverside environment."
    },
    {
        title: "Hanuman Garhi",
        description:
            "Hanuman Garhi is a famous temple dedicated to Lord Hanuman, located on a hilltop in Ayodhya. It offers panoramic views and is an essential stop for devotees visiting the city."
    },
    {
        title: "Kanak Bhawan",
        description:
            "Kanak Bhawan is a beautiful temple dedicated to Lord Ram and Goddess Sita, known for its intricate architecture and deep religious significance in Ayodhya."
    },
    {
        title: "Nageshwarnath Temple",
        description:
            "Nageshwarnath Temple is one of the ancient temples in Ayodhya believed to be established by Kush, son of Lord Ram. It is an important spiritual landmark for pilgrims."
    },
    {
        title: "Guptar Ghat",
        description:
            "Guptar Ghat is a serene riverbank on the Saryu River associated with Lord Ram’s spiritual departure. It is a peaceful location for meditation and reflection."
    },
    {
        title: "Treta Ke Thakur",
        description:
            "Treta Ke Thakur is an ancient temple believed to mark the site of significant events from the Ramayana era, attracting devotees and history enthusiasts."
    },
    {
        title: "Ram Ki Paidi",
        description:
            "Ram Ki Paidi is a series of ghats along the Saryu River developed for pilgrims, offering a clean and organized space for bathing and evening aarti."
    },
    {
        title: "Bharat Kund (Near Ayodhya)",
        description:
            "Bharat Kund is a sacred site associated with Bharat, brother of Lord Ram. It is a peaceful pilgrimage spot often included in Ayodhya travel itineraries."
    },
    {
        title: "Faizabad Historical Area",
        description:
            "Faizabad, near Ayodhya, offers historical significance with old monuments and architecture, adding cultural value to the pilgrimage journey."
    }
],



services: [
{
name: "Mumbai to Ayodhya Cab",
description: "Mumbai Airport Cab offers Mumbai to Ayodhya Cab service for safe, comfortable, and reliable long-distance pilgrimage travel to the sacred city of Ayodhya. Whether you are travelling for Ram Mandir darshan, family pilgrimage, religious tour, or extended spiritual journey, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury options. Our professional chauffeurs are experienced in long highway routes and ensure smooth driving, safety, and timely arrival. With doorstep pickup from Mumbai, flexible travel plans, transparent pricing, luggage assistance, and 24x7 support, we make your journey peaceful, comfortable, and stress-free."
},
{
name: "Mumbai to Ayodhya Taxi",
description: "Mumbai to Ayodhya Taxi service by Mumbai Airport Cab ensures dependable and comfortable intercity travel for pilgrims and families. Our clean, air-conditioned taxis are driven by experienced chauffeurs trained for long-distance routes. We offer flexible pickup options, safe highway travel, and reliable service for a smooth journey from Mumbai to Ayodhya at any time."
},
{
name: "Mumbai to Ayodhya Cab Fare",
description: "Mumbai to Ayodhya Cab Fare with Mumbai Airport Cab is transparent, affordable, and based on vehicle type, distance, and travel requirements. We provide clear pricing with no hidden charges, offering budget to premium travel options. Whether one-way or round trip, we ensure cost-effective pilgrimage travel with comfort and reliability."
},
{
name: "Mumbai to Ayodhya Car Rental",
description: "Mumbai Airport Cab offers Mumbai to Ayodhya Car Rental service with chauffeur-driven vehicles for long-distance spiritual travel. Our fleet includes comfortable sedans and spacious SUVs suitable for families and groups. We ensure safe driving, flexible itineraries, and smooth travel experience throughout the journey."
},
{
name: "Mumbai to Ayodhya One Way Cab",
description: "Mumbai to Ayodhya One Way Cab service provides affordable travel for passengers who need only a single journey without return charges. Mumbai Airport Cab ensures transparent pricing, comfortable vehicles, and professional drivers for relocation, pilgrimage, and intercity travel needs."
},
{
name: "Mumbai to Ayodhya Outstation Cab",
description: "Mumbai to Ayodhya Outstation Cab service offers reliable long-distance transportation for spiritual and family travel. Mumbai Airport Cab provides well-maintained vehicles, experienced chauffeurs, and flexible schedules for a safe and comfortable journey across states."
},
{
name: "Mumbai to Ayodhya Taxi Service",
description: "Mumbai Airport Cab provides Mumbai to Ayodhya Taxi Service with professional drivers, clean vehicles, and 24x7 availability. Our service ensures punctual pickup, smooth highway travel, and safe transportation for pilgrims and long-distance travellers."
},
{
name: "Mumbai to Ayodhya Long Distance Cab",
description: "Mumbai to Ayodhya Long Distance Cab service is designed for extended highway journeys with maximum comfort and safety. Mumbai Airport Cab ensures experienced chauffeurs, air-conditioned vehicles, luggage support, and smooth travel planning for stress-free long trips."
},
{
name: "Mumbai to Ayodhya Innova Cab",
description: "Mumbai Airport Cab offers Mumbai to Ayodhya Innova Cab service for families and groups needing spacious and comfortable travel. Our Innova vehicles provide ample seating, luggage space, and smooth ride quality, making long pilgrimage journeys more relaxing and convenient."
},
{
name: "Mumbai to Ayodhya Sleeper Cab",
description: "Mumbai to Ayodhya Sleeper Cab service is designed for passengers who prefer rest and comfort during long overnight journeys. Mumbai Airport Cab ensures safe driving, comfortable seating arrangements, and smooth highway travel for a restful travel experience."
},
{
name: "Mumbai to Ayodhya Pilgrimage Cab",
description: "Mumbai to Ayodhya Pilgrimage Cab service is specially designed for devotees visiting Ram Mandir and other sacred sites in Ayodhya. Mumbai Airport Cab provides experienced drivers, flexible schedules, and comfortable vehicles to ensure a peaceful spiritual journey."
},
{
name: "Mumbai to Ayodhya Round Trip Cab",
description: "Mumbai to Ayodhya Round Trip Cab service offers complete return journey solutions for families, groups, and pilgrims. Mumbai Airport Cab ensures flexible scheduling, professional chauffeurs, and comfortable vehicles for a smooth round trip experience."
},
{
name: "Mumbai to Ayodhya Family Cab",
description: "Mumbai to Ayodhya Family Cab service provides safe and comfortable transportation for families travelling together for pilgrimage or vacation. We offer spacious vehicles, experienced drivers, and luggage-friendly travel for a stress-free journey."
},
{
name: "Mumbai to Ayodhya Religious Tour Cab",
description: "Mumbai to Ayodhya Religious Tour Cab service provides organized spiritual travel for devotees visiting temples and holy sites. Mumbai Airport Cab ensures comfortable vehicles, flexible itineraries, and safe highway travel for a meaningful pilgrimage experience."
},
{
name: "Mumbai to Ayodhya Highway Cab",
description: "Mumbai to Ayodhya Highway Cab service ensures safe and efficient long-distance travel via major highway routes. Mumbai Airport Cab provides professional chauffeurs, optimized routes, and comfortable vehicles for smooth intercity journeys."
},
{
name: "Mumbai to Ayodhya Travel Package Cab",
description: "Mumbai to Ayodhya Travel Package Cab service offers customized pilgrimage packages including travel planning, vehicle selection, and flexible itineraries. Mumbai Airport Cab ensures comfortable and well-organized travel for families and groups."
},
{
name: "Mumbai to Ayodhya Budget Cab",
description: "Mumbai to Ayodhya Budget Cab service provides economical travel solutions without compromising safety or comfort. Mumbai Airport Cab ensures affordable pricing, reliable drivers, and clean vehicles for cost-effective pilgrimage journeys."
},
{
name: "Mumbai to Ayodhya Express Cab",
description: "Mumbai to Ayodhya Express Cab service offers fast and efficient transportation for urgent and priority travel needs. Mumbai Airport Cab ensures quick pickup, optimized routes, and professional drivers for timely arrival."
},
{
name: "Mumbai to Ayodhya Night Travel Cab",
description: "Mumbai to Ayodhya Night Travel Cab service provides safe and reliable overnight transportation for long-distance pilgrims. Mumbai Airport Cab ensures experienced chauffeurs, secure travel conditions, and comfortable vehicles for peaceful night journeys."
}
],

tableData: [
["Mumbai to Ayodhya Cab","Mumbai to Ayodhya Taxi"],
["Mumbai to Ayodhya Cab Fare","Mumbai to Ayodhya Car Rental"],
["Mumbai to Ayodhya One Way Cab","Mumbai to Ayodhya Outstation Cab"],
["Mumbai to Ayodhya Taxi Service","Mumbai to Ayodhya Long Distance Cab"],
["Mumbai to Ayodhya Innova Cab","Mumbai to Ayodhya Sleeper Cab"],
["Mumbai to Ayodhya Pilgrimage Cab","Mumbai to Ayodhya Religious Tour Cab"],
["Mumbai to Ayodhya Round Trip Cab","Mumbai to Ayodhya Family Cab"],
["Mumbai to Ayodhya Highway Cab","Mumbai to Ayodhya Travel Package Cab"],
["Mumbai to Ayodhya Budget Cab","Mumbai to Ayodhya Express Cab"]
],










whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Ayodhya Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Ayodhya Cab services for pilgrims, families, tourists, senior citizens, and groups seeking comfortable long-distance travel."
    },
    {
        WhyChooseheading: "Convenient Ayodhya Darshan Travel",
        WhyChoosedescription: "Travel comfortably to the holy city of Ayodhya, home to Shri Ram Janmabhoomi Mandir and several important spiritual and historical attractions."
    },
    {
        WhyChooseheading: "Perfect for Religious and Family Tours",
        WhyChoosedescription: "Our cab service is ideal for Ram Mandir Darshan, family pilgrimages, spiritual tours, group travel, and customized religious journeys."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to their travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Packages Available",
        WhyChoosedescription: "Whether you require a one-way transfer, round trip, multi-day pilgrimage tour, or customized itinerary, we offer flexible travel solutions."
    },
    {
        WhyChooseheading: "Pickup Available Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and nearby areas."
    },
    {
        WhyChooseheading: "Experienced Drivers for Interstate Travel",
        WhyChoosedescription: "Our professional chauffeurs are experienced in long-distance interstate routes and ensure safe, smooth, and comfortable travel."
    },
    {
        WhyChooseheading: "Ideal for Families, Senior Citizens, and Groups",
        WhyChoosedescription: "From individual devotees and families to pilgrimage groups and senior citizens, we provide suitable vehicles for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Mumbai to Ayodhya Cabs?",
        answer: "Ayodhya is one of India's most important religious destinations, attracting devotees visiting Shri Ram Janmabhoomi Mandir and other sacred sites."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Ayodhya?",
        answer: "Yes, one-way cab services are available along with round-trip and customized pilgrimage packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Ayodhya travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available based on passenger count and comfort requirements."
    },
    {
        question: "Do you provide multi-day Ayodhya tour packages?",
        answer: "Yes, customers can book multi-day pilgrimage tours including Ayodhya and nearby religious destinations."
    },
    {
        question: "Can families and senior citizens travel comfortably to Ayodhya?",
        answer: "Yes, we provide spacious and comfortable vehicles suitable for families, elderly passengers, and long-distance religious journeys."
    },
    {
        question: "Are Tempo Travellers available for pilgrimage groups?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for large families, religious groups, and organized pilgrimage tours."
    },
    {
        question: "Can I start my journey from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Can I include other religious destinations during the trip?",
        answer: "Yes, customers can customize their itinerary and include destinations such as Prayagraj, Varanasi, Chitrakoot, and other pilgrimage sites."
    },
    {
        question: "Is advance booking recommended for Ayodhya travel?",
        answer: "Yes, advance booking is highly recommended, especially during festival seasons, holidays, and major religious events."
    },
    {
        question: "How can I book a Mumbai to Ayodhya Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Mahendra Joshi",
        feedback:
            "Our Ayodhya pilgrimage was organized beautifully. The vehicle was comfortable for the long journey, and the driver was extremely cooperative throughout the trip.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Rekha Sharma",
        feedback:
            "We traveled with senior family members for Ram Mandir Darshan and had a wonderful experience. The cab was spacious, clean, and the service was excellent from start to finish.",
        rating: 5
    }
];






































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Ayodhya Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-ayodhya-cab.jpg",
"description": "Book Mumbai to Ayodhya cab service for long-distance pilgrimage and outstation travel. Mumbai Airport Cabs offers comfortable one-way and round-trip taxi options including Innova and sleeper vehicles with professional drivers, safe travel, and 24x7 availability.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-ayodhya-cab"
}
};





    return (
        <div>



<Helmet>
  <title>Mumbai to Ayodhya Cab | Pilgrimage Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Ayodhya cab for pilgrimage and long-distance travel. Safe and comfortable taxi service with Innova, sedan, and sleeper options, available 24x7 with professional drivers."
/>

<meta
 name="keywords"
 content="mumbai to ayodhya cab, mumbai to ayodhya taxi, mumbai to ayodhya cab fare, mumbai to ayodhya car rental, mumbai to ayodhya one way cab, mumbai to ayodhya outstation cab, mumbai to ayodhya taxi service, mumbai to ayodhya long distance cab, mumbai to ayodhya innova cab, mumbai to ayodhya sleeper cab, mumbai to ayodhya pilgrimage cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/54.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoayodhyacab;